import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from "next/navigation";
import React, { useMemo } from "react";
const TutorialLink = (param)=>{
    let { className } = param;
    const { locale = "en" } = useParams();
    const t = useTranslations("");
    const link = useMemo(()=>{
        if (locale === "zh") {
            return "https://web3.bitget.cloud/zh-CN/blog/articles/bwb-to-bgb-swap-tutorial-faqs";
        } else {
            return "https://web3.bitget.com/en/blog/articles/bwb-to-bgb-swap-tutorial-faqs";
        }
    }, [
        locale
    ]);
    return /*#__PURE__*/ _jsx("a", {
        href: link,
        className: "text-[var(--primary)] text-12px ".concat(className),
        children: t("swap_faq_tutorial")
    });
};
export default TutorialLink;
